import CancelIcon from '@mui/icons-material/Cancel';
import { Tooltip } from '@mui/material'
import React from 'react'

export default function CancelIconcomp({onClick, tooltipTitle, fontSize}) {
  return (
    <>
      <Tooltip title={tooltipTitle}>
                  <CancelIcon
                    style={{ fontSize: fontSize || "1.2rem", cursor: "pointer" }}
                    variant="contained"
                    color="error"
                    onClick={onClick}
                  />
                </Tooltip>
                </>
  )
}
